export default __webpack_public_path__ + "images/mobile-bg-pin.png?c9a61df2ed45829ee577358660adb195";